import { DataTableButton } from "@/components/data-table/components/DataTableButton";
import { ReadProjectStorePeriod } from "@/types/projectStorePeriod";
import { Row } from "@tanstack/react-table";
import { X } from "lucide-react";
import { useProjectStoreContext } from "./ProjectStoreContext";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface RemoveStoreButtonProps {
  row: Row<ReadProjectStorePeriod>;
  disabled?: boolean;
}

const RemoveStoreButton = ({ row, disabled }: RemoveStoreButtonProps) => {
  const { clearAndRemoveSingleStore } = useProjectStoreContext();

  const handleRemoveStore = useCallback(() => {
    clearAndRemoveSingleStore(row);
  }, [row, clearAndRemoveSingleStore]);

  const { t } = useTranslation();

  return (
    <DataTableButton onClick={handleRemoveStore} disabled={disabled}>
      <X className="w-4 h-4" /> {t("projects.projectStores.markForRemoval")}
    </DataTableButton>
  );
};

export default RemoveStoreButton;
